/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetReportTab200ResponseRating
 */
export interface GetReportTab200ResponseRating {
    /**
     * 
     * @type {number}
     * @memberof GetReportTab200ResponseRating
     */
    score: number;
    /**
     * 
     * @type {string}
     * @memberof GetReportTab200ResponseRating
     */
    comment?: string;
}

/**
 * Check if a given object implements the GetReportTab200ResponseRating interface.
 */
export function instanceOfGetReportTab200ResponseRating(value: object): value is GetReportTab200ResponseRating {
    if (!('score' in value) || value['score'] === undefined) return false;
    return true;
}

export function GetReportTab200ResponseRatingFromJSON(json: any): GetReportTab200ResponseRating {
    return GetReportTab200ResponseRatingFromJSONTyped(json, false);
}

export function GetReportTab200ResponseRatingFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetReportTab200ResponseRating {
    if (json == null) {
        return json;
    }
    return {
        
        'score': json['score'],
        'comment': json['comment'] == null ? undefined : json['comment'],
    };
}

export function GetReportTab200ResponseRatingToJSON(json: any): GetReportTab200ResponseRating {
    return GetReportTab200ResponseRatingToJSONTyped(json, false);
}

export function GetReportTab200ResponseRatingToJSONTyped(value?: GetReportTab200ResponseRating | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'score': value['score'],
        'comment': value['comment'],
    };
}

